var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableLamp2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.54669 6.58289C3.9431 6.88555 3.81256 7.69228 4.28974 8.17082L9.34083 13.2364C9.81801 13.7149 10.6224 13.584 10.9242 12.9787L13.0354 8.74421C13.0829 8.64889 13.1455 8.56188 13.2206 8.48652L13.9386 7.76646L19.0949 12.2911C19.6194 12.7513 19.6609 13.5551 19.1867 14.0672L14.5957 19.0255H10.2405C9.6945 19.0255 9.25185 19.4694 9.25185 20.017V21.0085C9.25185 21.5561 9.6945 22 10.2405 22H19.1386C19.6846 22 20.1273 21.5561 20.1273 21.0085V20.017C20.1273 19.4694 19.6846 19.0255 19.1386 19.0255H16.6195L20.2735 15.0792C21.3166 13.9526 21.2252 12.1843 20.0715 11.1718L14.9896 6.71247L15.2045 6.497C15.5906 6.10979 15.5906 5.48201 15.2045 5.0948L12.4081 2.2904C12.022 1.9032 11.396 1.9032 11.0099 2.2904L9.02603 4.27993C8.95089 4.35528 8.86413 4.418 8.76908 4.46566L4.54669 6.58289Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32512 10.3097C4.24082 11.0362 4.47659 11.7931 5.03241 12.3505C5.58823 12.9079 6.34291 13.1444 7.06744 13.0598L4.32512 10.3097Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableLamp2);
export default __webpack_public_path__ + "static/media/table-lamp-2.f91de9bfbfaeab1a50b2156ad74a9816.svg";
export { ForwardRef as ReactComponent };